import { useRef, useLayoutEffect } from "react";

export function useScrollToTopOnChange(deps: unknown) {
  const ref = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    ref.current?.scrollTo(0, 0);
  }, [deps]);

  return ref;
}
